import { h, render, Component } from 'preact';
import { classNames} from '../utils/utils';

class TxrInput extends Component {
    state = {
        isMobileMenuOpened: false,
        isScrolled: false
    }

    getFirstError = ()  => {
        let errors = Object.entries(this.props.model.errors);
        let firstError = '';
        for (const [key, value] of errors) {
            if(!!value) {
             firstError = this.props.errors[key];
             this.hasError = true;
             return firstError;
            }
        }
        this.hasError = false;
        return '';
     }
     txrEdit = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }
   txrEditChange = (e) => {
        this.props.model.touched = true;
        this.props.model.value = e.target.value;
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
    }

    render() {
        return (
            <div class={'txr-input' + (this.props.model.invalid ? ' invalid' : '') + (this.props.model.value || this.props.existvalue ? ' has-value' : '')}>
                <div class="txr-input__container">
                    <textarea onKeyup={(e) => this.txrEdit(e)} onChange={(e) => this.txrEditChange(e)} class="txr-input__input" rows="1" value={this.props.model.value}></textarea>
                    <label class="txr-input__label">{this.props.label}</label>
                    { this.props.rightSlot &&
                        <div class="txr-input__right-slot">
                            {this.props.rightSlot}
                        </div>
                    }
                </div>
                { this.props.errors &&
                    <div class="txr-input__errors">
                        {this.getFirstError()}
                    </div>
                }
                { this.props.bottomSlot &&
                 <div class="txr-input__bottom-slot">{this.props.bottomSlot}</div>
                }
            </div>
        )
    }
}

export default TxrInput;